export enum OneClickContractType {
  Contract = 'contract',
  Invoice = 'invoice',
  ZCA = 'ZCA',
}
